var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('headerM',{attrs:{"logo":_vm.confData && _vm.confData.main_logo ? _vm.confData.main_logo : null,"smallLogo":_vm.confData && _vm.confData.login_logo ? _vm.confData.login_logo : null}}),_c('router-view',{class:{
    backgroundImg: _vm.showBackgroundImg, 
    backgroundGradient: !_vm.showBackgroundImg
  }}),_c('FooterComp'),(_vm.showGoToTop)?_c('goTop',{staticStyle:{"position":"fixed","bottom":"10px","right":"70px"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }